import request from '@/utils/request'

// 获取用户积分信息
export function getPointsInfo(userId) {
  return request({
    url: `/points/info/${userId}`,
    method: 'get'
  })
}

// 获取用户积分余额
export function getPointsBalance(userId) {
  return request({
    url: `/points/balance/${userId}`,
    method: 'get'
  })
}

// 充值积分（模拟）
export function rechargePoints(data) {
  return request({
    url: '/points/recharge',
    method: 'post',
    data
  })
}

// 消费积分
export function consumePoints(data) {
  return request({
    url: '/points/consume',
    method: 'post',
    data
  })
}

// 检查积分是否足够
export function checkPointsBalance(userId, amount) {
  return request({
    url: `/points/check/${userId}/${amount}`,
    method: 'get'
  })
}

// 查询积分变动记录
export function getPointsRecords(userId, type, limit) {
  return request({
    url: `/points/records/${userId}`,
    method: 'get',
    params: { type, limit }
  })
}
